import * as React from 'react'
import { ReactCalendarGroupRendererProps, TimelineGroupBase } from 'react-calendar-timeline'

interface Props extends ReactCalendarGroupRendererProps<TimelineGroupBase & ILineItem> {
  onClick: (item: ILineItem) => void
}

const SchedulerGroup: React.FC<Props> = ({ group, onClick }) => (
  <button
    className="font-weight-bold text-heading text-xs pointer text-truncate text-left"
    onClick={() => onClick(group)}
    style={{ backgroundColor: 'unset', border: 'none', padding: 0, width: '100%' }}>
    {group.product?.name || group.categorySegment?.name}
  </button>
)

export default SchedulerGroup
